import { render, staticRenderFns } from "./DetailsAgreement.vue?vue&type=template&id=72fc5274&scoped=true&"
import script from "./DetailsAgreement.vue?vue&type=script&lang=js&"
export * from "./DetailsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./DetailsAgreement.vue?vue&type=style&index=0&id=72fc5274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc5274",
  null
  
)

export default component.exports